import React, { Component } from "react";
import "./MAMCAResult.css";
import Cookie from 'js-cookie';
import {
    message, Divider, Spin,
    Button, Steps, Row, Col,
    InputNumber, Form

} from 'antd';
import { Link } from "react-router-dom";
import ReactEcharts from 'echarts-for-react';
import { prepareBoxplotData } from 'echarts/extension/dataTool';

var echarts = require("echarts");
// echarts.dataTool = require("echarts/extension/dataTool"); //import dataTool
export default class InvitedMAMCAResult extends Component {
    constructor(props) {
        super(props);

        const panes = [
            { title: 'Tab 1', key: '1' },
        ];

        this.state = {
            email: Cookie.get("email"),
            loading: true, //the loading status default true
            project: {},
            projectActorGroup: [],
            number: 0,
            panes,
            activeKey: '1',
            changedName: "",
            chart: "Overall result",
            selectedCriterion: "",
            activeKey: Cookie.get('activeKey'),            
        };
    }

    onStepChange = current => {
        if (current === 0) {
            this.props.history.push(`/invitedalternative/${this.props.match.params.projectid}/${this.props.match.params.actorid}`)
        }
        if (current === 1) {
            this.props.history.push(`/invitedcriteria/${this.props.match.params.projectid}/${this.props.match.params.actorid}`)
        }
        if (current === 2) {
            this.props.history.push(`/invitedweight/${this.props.match.params.projectid}/${this.props.match.params.actorid}`)
        }
        if (current === 3) {
            this.props.history.push(`/invitedevaluation/${this.props.match.params.projectid}/${this.props.match.params.actorid}`)
        }
    }

    onChange = (activeKey) => {
        Cookie.set('activeKey', activeKey);
        this.setState({
            activeKey: activeKey,
            selectedCriterion: ""
        });
    }

    handleNumberChange = (value) => {
        let prop = 0
        let criterion = ""
        this.state.projectActorGroup.actorCriteria.forEach(obj => { //change weight


            if (obj.criteriaName === this.state.changedName) { //this is criterion
                obj.actors.forEach(aobj => {

                    if (aobj.actorEvaluator === Cookie.get("email")) {

                        prop = (1 - value) / (1 - aobj.actorCriteriaWeight)
                        aobj.actorCriteriaWeight = value
                    }
                })
                // prop = (1 - value) / (1 - obj.criteriaWeight)
                // obj.criteriaWeight = value
            }




        })

        this.state.projectActorGroup.actorCriteria.forEach(obj => { //set new weight

            if (obj.criteriaName !== this.state.changedName && obj.criteriaName !== criterion) { //this is criterion
                obj.actors.forEach(aobj => {
                    if (aobj.actorEvaluator === Cookie.get("email")) {
                        aobj.actorCriteriaWeight = aobj.actorCriteriaWeight * prop

                    }
                })
                //  obj.criteriaWeight = obj.criteriaWeight * prop
            }

        })


        if (value >= 0.1 && value <= 0.9) {

            this.setState({
                number: value,
            })
        }
    }

    getMAMCAOverallResult = () => {
        let actorName = []
        let lineSymbol = ['circle', 'rect', 'roundRect', 'triangle', 'diamond', 'pin', 'arrow'] //can be more
        let num = 0

        let seriesData = []
        if (this.state.project.projectActorGroup) {
            this.state.project.projectActorGroup.forEach(obj => {
                actorName.push(obj.actorGroupName)
            })
        }
        if (this.state.project.projectAlternatives) { //each alternative has one line

            this.state.project.projectAlternatives.forEach(obj => {
                let line = {} // each alternative has one line for all actors
                let lineData = [] //alternative for one, push each score for each actors
                this.state.project.projectActorGroup.forEach(aobj => { //each actor calculate the result
                    let overallscore = 0
                    let numberEval = 0
                    if (aobj.actorCriteria && aobj.actorCriteria.length !== 0) {
                        if (aobj.actorCriteria[0].actors && aobj.actorCriteria[0].actors.length !== 0) { //there are actors
                            if (aobj.actorCriteria[0].subCriteria && aobj.actorCriteria[0].subCriteria.length) { //there are subCriteria
                                aobj.actorCriteria[0].subCriteria[0].actors.forEach(subCount => {
                                    if (subCount.actorSubCriteriaResult && subCount.actorSubCriteriaResult.length !== 0 && subCount.actorSubCriteriaWeight !== undefined) { //there is evaluation
                                        numberEval++ //only count the evaluated result
                                    }
                                })
                            }
                            else {
                                aobj.actorCriteria[0].actors.forEach(count => {
                                    if (count.actorCriteriaResult && count.actorCriteriaResult.length !== 0 && count.actorCriteriaWeight !==undefined) { //there is evaluation
                                        numberEval++
                                    }
                                })
                            }
                        }
                        aobj.actorCriteria.forEach(caobj => { //for each criteria
                            let cWeight = 0
                            if (caobj.actors && caobj.actors.length !== 0) { //there is actors
                                caobj.actors.forEach(acaobj => {   //for each actor
                                    // if(acaobj.actorEvaluator === Cookie.get("email")){ //find the evaluator

                                    cWeight = acaobj.actorCriteriaWeight
                                    if (caobj.subCriteria && caobj.subCriteria.length !== 0) { //there is subCriteria
                                        caobj.subCriteria.forEach(subobj => {
                                            if (subobj.actors && subobj.actors.length !== 0) { //there is result
                                                subobj.actors.forEach(asubobj => {
                                                    if (asubobj.actorSubCriteriaResult && asubobj.actorSubCriteriaResult.length !== 0 && asubobj.actorSubCriteriaWeight !== undefined) {//only count the evaluated weight
                                                        if (asubobj.actorEvaluator === acaobj.actorEvaluator) { //find the evaluator
                                                            asubobj.actorSubCriteriaResult.forEach(rasubobj => {
                                                                if (rasubobj.subCriteriaAlternativeName === obj.alternativeName) {
                                                                    overallscore = cWeight * asubobj.actorSubCriteriaWeight * rasubobj.subCriteriaAlternativeScore + overallscore
                                                                }
                                                            })
                                                        }
                                                    }
                                                })
                                            }
                                        })
                                    }
                                    else { //there is no subCriteria
                                        if (acaobj.actorCriteriaResult && acaobj.actorCriteriaResult.length !== 0 && acaobj.actorCriteriaWeight !==undefined) {
                                            acaobj.actorCriteriaResult.forEach(racaobj => {
                                                if (racaobj.criteriaAlternativeName === obj.alternativeName) {
                                                    overallscore = overallscore + (racaobj.criteriaAlternativeScore * cWeight)
                                                }
                                            })
                                        }
                                    }
                                })

                            }
                        })
                    }
                    overallscore = overallscore / numberEval
                    lineData.push(overallscore.toFixed(3))
                })
                line.name = obj.alternativeName
                line.data = lineData
                line.symbol = lineSymbol[num]
                line.type = "line"
                line.symbolSize = 15
                line.lineStyle = {
                    width: 4
                }
                num++
                seriesData.push(line)
            })
        }
        var option = {}
        if (this.state.project.projectAlternatives) {
            option = {
                // color: ['#4C6F74'],
                title: {
                    text: `Overall result`
                },
                legend: {
                    top: '5%',
                    textStyle: {
                        fontSize: 16 // Set the legend font size here
                    }
                },
                tooltip: {
                    trigger: 'axis',
                    axisPointer: {            // 坐标轴指示器，坐标轴触发有效
                        type: 'shadow'        // 默认为直线，可选为：'line' | 'shadow'
                    }
                },
                toolbox: {
                    feature: {
                        saveAsImage: {
                            title: "Save"
                        },
                        dataView: { title: "show data", show: true, readOnly: false },
                    }
                },
                grid: {
                    left: '3%',
                    right: '4%',
                    bottom: '3%',
                    containLabel: true
                },
                xAxis: [
                    {
                        type: 'category',
                        data: actorName,
                        axisLabel: {
                            show: true,
                            interval: 0,
                            // Use callback function; function parameters are axis index
                            formatter: function (value, index) {
                                // let textArray = value.split(" ")
                                let final = ""
                                if(parseInt(value.length/20) === 0){ //not long enough
                                    final = value
                                }
                                else{
                                    for (let i = 0; i < parseInt(value.length/20)+1; i++) {
                                        let t = value.substring((i)*20, (i+1)*20)+ '\n';
                                        final += t
                                      }
                                }
     
                                // var texts = value.substring(0, 5);
                                return final;
                            }
                        }
                    }
                ],
                yAxis: [
                    {
                        type: 'value',
                        // max: 1,
                    }
                ],
                series: seriesData
            };
        }
        return option

    }


    getMAMCAEvaluation = () => {
        let actorName = []
        let lineSymbol = ['circle', 'rect', 'roundRect', 'triangle', 'diamond', 'pin', 'arrow'] //can be more
        let num = 0
        // if (this.state.project.projectAlternatives) { //after loading
        //     this.state.project.projectAlternatives[0].alternativeActors.forEach(obj => {
        //         actorName.push(obj.actorName)
        //     })
        // }
        let seriesData = []
        if (this.state.project.projectActorGroup) {
            this.state.project.projectActorGroup.forEach(obj => {
                actorName.push(obj.actorGroupName)
            })
        }
        if (this.state.project.projectAlternatives) { //each alternative has one line

            this.state.project.projectAlternatives.forEach(obj => {
                let line = {} // each alternative has one line for all actors
                let lineData = [] //alternative for one, push each score for each actors
                this.state.project.projectActorGroup.forEach(aobj => { //each actor calculate the result
                    let overallscore = 0
                    aobj.actorCriteria.forEach(caobj => { //for each criteria
                        let cWeight = 0
                        if (caobj.actors && caobj.actors.length !== 0) { //there is actors
                            caobj.actors.forEach(acaobj => { //for each actor
                                if (acaobj.actorEvaluator === Cookie.get("email")) { //find the evaluator
                                    cWeight = acaobj.actorCriteriaWeight
                                    if (caobj.subCriteria && caobj.subCriteria.length !== 0) { //there is subCriteria
                                        caobj.subCriteria.forEach(subobj => {
                                            if (subobj.actors && subobj.actors.length !== 0) { //there is result
                                                subobj.actors.forEach(asubobj => {
                                                    if (asubobj.actorEvaluator === Cookie.get("email")) { //find the evaluator
                                                        asubobj.actorSubCriteriaResult.forEach(rasubobj => {
                                                            if (rasubobj.subCriteriaAlternativeName === obj.alternativeName) {
                                                                overallscore = cWeight * asubobj.actorSubCriteriaWeight * rasubobj.subCriteriaAlternativeScore + overallscore
                                                            }

                                                        })
                                                    }
                                                })
                                            }
                                        })
                                    }
                                    else { //there is no subCriteria
                                        acaobj.actorCriteriaResult.forEach(racaobj => {
                                            if (racaobj.criteriaAlternativeName === obj.alternativeName) {
                                                overallscore = overallscore + (racaobj.criteriaAlternativeScore * cWeight)
                                            }
                                        })
                                    }
                                }
                            })

                        }
                    })
                    lineData.push(overallscore.toFixed(3))
                })
                line.name = obj.alternativeName
                line.data = lineData
                line.symbol = lineSymbol[num]
                line.type = "line"
                line.symbolSize = 15
                line.lineStyle = {
                    width: 4
                }
                num++
                seriesData.push(line)
            })
        }
        var option = {}
        if (this.state.project.projectAlternatives) {
            option = {
                // color: ['#4C6F74'],
                title: {
                    text: `Evaluation result`
                },
                legend: {
                    top: '5%',
                    textStyle: {
                        fontSize: 16 // Set the legend font size here
                    }
                },
                tooltip: {
                    trigger: 'axis',
                    axisPointer: {            // 坐标轴指示器，坐标轴触发有效
                        type: 'shadow'        // 默认为直线，可选为：'line' | 'shadow'
                    }
                },
                toolbox: {
                    feature: {
                        saveAsImage: {
                            title: "Save"
                        },
                        dataView: { title: "show data", show: true, readOnly: false },
                    }
                },
                grid: {
                    left: '3%',
                    right: '4%',
                    bottom: '3%',
                    containLabel: true
                },
                xAxis: [
                    {
                        type: 'category',
                        data: actorName,
                        axisLabel: {
                            show: true,
                            interval: 0,
                            // Use callback function; function parameters are axis index
                            formatter: function (value, index) {
                                // let textArray = value.split(" ")
                                let final = ""
                                if(parseInt(value.length/20) === 0){ //not long enough
                                    final = value
                                }
                                else{
                                    for (let i = 0; i < parseInt(value.length/20)+1; i++) {
                                        let t = value.substring((i)*20, (i+1)*20)+ '\n';
                                        final += t
                                      }
                                }
     
                                // var texts = value.substring(0, 5);
                                return final;
                            }
                        }
                    }
                ],
                yAxis: [
                    {
                        type: 'value',
                        // max: 1,
                    }
                ],
                series: seriesData
            };
        }
        return option
    }


    getMCASensitivityAnalysis = () => {
        let criteriaWeightValue = []
        let criteriaName = []
        let lineSymbol = ['circle', 'rect', 'roundRect', 'triangle', 'diamond', 'pin', 'arrow']
        let num = 0
        if (this.state.project.projectAlternatives) { //after loading
            this.state.projectActorGroup.actorCriteria.forEach(c => {

                criteriaName.push(c.criteriaName)
                c.actors.forEach(cobj => {
                    if (cobj.actorEvaluator === Cookie.get("email")) {

                        criteriaWeightValue.push(cobj.actorCriteriaWeight.toFixed(3))
                    }
                })
            })

        }
        let seriesData = []
        if (this.state.project.projectAlternatives) {
            this.state.project.projectAlternatives.forEach(obj => {
                let line = {}
                let lineData = []
                line.name = obj.alternativeName
                let finalResult = 0
                this.state.projectActorGroup.actorCriteria.forEach(c => {
                    let weightNumber

                    if (c.subCriteria && c.subCriteria.length !== 0) { //there is sub-criterion
                        let d = 0

                        c.actors.forEach(a => {
                            if (a.actorEvaluator === Cookie.get("email")) {
                                weightNumber = a.actorCriteriaWeight

                            }
                        })


                        c.subCriteria.forEach(cSub => {
                            cSub.actors.forEach(sobj => {
                                if (sobj.actorEvaluator === Cookie.get("email")) {
                                    sobj.actorSubCriteriaResult.forEach(srobj => {
                                        if (srobj.subCriteriaAlternativeName === obj.alternativeName) {
                                            d += sobj.actorSubCriteriaWeight * srobj.subCriteriaAlternativeScore
                                        }
                                    })
                                }
                            })
                        })


                        lineData.push(d.toFixed(3))
                        finalResult += d * weightNumber
                    }
                    else {
                        c.actors.forEach(aobj => {
                            if (aobj.actorEvaluator === Cookie.get("email")) {
                                aobj.actorCriteriaResult.forEach(raobj => {
                                    if (raobj.criteriaAlternativeName === obj.alternativeName) {

                                        lineData.push(raobj.criteriaAlternativeScore)
                                        finalResult += raobj.criteriaAlternativeScore * aobj.actorCriteriaWeight
                                    }
                                })

                            }


                        })
                    }
                })

                lineData.push(finalResult.toFixed(3))
                line.data = lineData
                line.symbol = lineSymbol[num]
                line.symbolSize = 12
                num++
                line.type = "line"
                line.lineStyle = {
                    width: 4
                }
                seriesData.push(line)

                // obj.alternativeActors.forEach(actor => {
                //     if (actor.actorName === this.state.project.projectActors[this.state.activeKey - 1].actorName) {
                //         actor.actorAlternativeResult.forEach(subObj => {
                //             lineData.push(subObj.actorCriteriaScore)
                //         })
                //         lineData.push(actor.actorAlternativeScore)
                //         line.name = obj.alternativeName
                //         line.data = lineData
                //         line.type = "line"
                //         line.lineStyle = {
                //             width: 4
                //         }
                //         seriesData.push(line)
                //     }
                // })
            })
        }
        criteriaName.push("Result score")
        seriesData.push({
            name: 'Weight value',
            type: 'bar',
            barWidth: '20%',
            itemStyle: {
                color: "#FFF",
                barBorderColor: 1
            },
            data: criteriaWeightValue,
            markPoint: {
                symbol: 'circle',
                symbolSize: 50,
            },
        })
        var option = {}
        if (this.state.project.projectAlternatives) {
            option = {
                // color: ['#4C6F74'],
                title: {
                    text: `Actor sensitivity analysis: ${this.state.projectActorGroup.actorGroupName}`
                },
                legend: {
                    top: '5%',
                    textStyle: {
                        fontSize: 16 // Set the legend font size here
                    }
                },
                tooltip: {
                    trigger: 'axis',
                    axisPointer: {            // 坐标轴指示器，坐标轴触发有效
                        type: 'shadow'        // 默认为直线，可选为：'line' | 'shadow'
                    }
                },
                toolbox: {
                    feature: {
                        saveAsImage: {
                            title: "Save"
                        },
                        dataView: { title: "show data", show: true, readOnly: false },
                    }
                },
                grid: {
                    left: '3%',
                    right: '4%',
                    bottom: '3%',
                    containLabel: true
                },
                xAxis: [
                    {
                        type: 'category',
                        data: criteriaName,
                        axisLabel: {
                            show: true,
                            interval: 0,
                            // Use callback function; function parameters are axis index
                            formatter: function (value, index) {
                                // let textArray = value.split(" ")
                                let final = ""
                                if(parseInt(value.length/20) === 0){ //not long enough
                                    final = value
                                }
                                else{
                                    for (let i = 0; i < parseInt(value.length/20)+1; i++) {
                                        let t = value.substring((i)*20, (i+1)*20)+ '\n';
                                        final += t
                                      }
                                }
     
                                // var texts = value.substring(0, 5);
                                return final;
                            }
                        }
                    }
                ],
                yAxis: [
                    {
                        type: 'value',
                        max: 1.00,
                        min: 0.00
                    }
                ],
                series: seriesData
            };
        }
        return option
    }


    getWeightOption = () => {
        let criteriaWeightValue = []
        let criteriaName = []
        let boxPlot = []
        var boxPlotData = {}
        let test = []
        let lineSymbol = ['circle', 'rect', 'roundRect', 'triangle', 'diamond', 'pin', 'arrow']
        let num = 0
        let evaList = []//to make the evaluator list
        if (this.state.project.projectAlternatives) { //after loading
            if (this.state.projectActorGroup.actorCriteria && this.state.projectActorGroup.actorCriteria.length !== 0) { //there are criteria
                if (this.state.projectActorGroup.actorCriteria[0].subCriteria && this.state.projectActorGroup.actorCriteria[0].subCriteria.length !== 0) { //there are subCriteria
                    this.state.projectActorGroup.actorCriteria[0].subCriteria[0].actors.forEach(subCount => {
                        if (subCount.actorSubCriteriaResult && subCount.actorSubCriteriaResult.length !== 0 && subCount.actorSubCriteriaWeight !== undefined) { //there is evaluation
                            evaList.push(subCount.actorEvaluator) //only count the evaluated result
                        }
                    })
                }
                else { //there is no subCriteria
                    this.state.projectActorGroup.actorCriteria[0].actors.forEach(count => {
                        if (count.actorCriteriaResult && count.actorCriteriaResult.length !== 0 && count.actorCriteriaWeight !==undefined) { //there is evaluation
                            evaList.push(count.actorEvaluator) //only count the evaluated result
                        }
                    })
                }
                this.state.projectActorGroup.actorCriteria.forEach(c => { //for each criterion
                    let boxSingleData = []
                    criteriaName.push(c.criteriaName)
                    if (c.actors && c.actors.length !== 0) { //there are actors
                        let aWeight = 0
                        c.actors.forEach(cobj => {
                            if (evaList.indexOf(cobj.actorEvaluator) !== -1) {//it's in the list
                                aWeight += cobj.actorCriteriaWeight
                                boxSingleData.push(cobj.actorCriteriaWeight)
                            }
                        })
                        aWeight = aWeight / evaList.length
                        criteriaWeightValue.push(aWeight.toFixed(3))
                        boxPlot.push(boxSingleData)
                    }
                })
            }
            boxPlotData = echarts.dataTool.prepareBoxplotData(boxPlot)
            for (let i = 0; i < boxPlotData.axisData.length; i++) {
                boxPlotData.axisData[i] = this.state.projectActorGroup.actorCriteria[i].criteriaName
            }
            boxPlotData.boxData.forEach(obj => { //array, push the data
                let testSub = []
                obj.forEach(subObj => { //eachData
                    subObj = Number(subObj).toFixed(3)
                    testSub.push(subObj)
                })
                test.push(testSub)
            })
        }
        let seriesData = []

        if (this.state.project.projectAlternatives) {
            this.state.project.projectAlternatives.forEach(obj => {
                let line = {}
                let lineData = []
                line.name = obj.alternativeName
                let overallscore = 0
                this.state.projectActorGroup.actorCriteria.forEach(c => { //for each criteria
                    if (c.subCriteria && c.subCriteria.length !== 0) { //there is sub-criterion
                        let cWeight = 0 //criterion weight
                        let subResult = 0 //for subcriteria result
                        c.actors.forEach(cobj => {
                            cWeight = cobj.actorCriteriaWeight // evaluator weight
                            c.subCriteria.forEach(subobj => {
                                if (subobj.actors && subobj.actors.length !== 0) { //there is result
                                    subobj.actors.forEach(asubobj => {
                                        if (asubobj.actorEvaluator === cobj.actorEvaluator && evaList.indexOf(asubobj.actorEvaluator) !== -1) { //find the evaluator
                                            asubobj.actorSubCriteriaResult.forEach(rasubobj => {
                                                if (rasubobj.subCriteriaAlternativeName === obj.alternativeName) {
                                                    overallscore = cWeight * asubobj.actorSubCriteriaWeight * rasubobj.subCriteriaAlternativeScore + overallscore // for the final score
                                                    subResult = asubobj.actorSubCriteriaWeight * rasubobj.subCriteriaAlternativeScore + subResult
                                                }

                                            })
                                        }
                                    })
                                }
                            })
                        })

                        subResult = subResult / evaList.length // average criterion score and push

                        lineData.push(subResult.toFixed(3))
                    }
                    else { //only criteria
                        if (c.actors && c.actors.length !== 0) {
                            let aScore = 0
                            c.actors.forEach(aobj => {
                                if (evaList.indexOf(aobj.actorEvaluator) !== -1) { //find the evaluator
                                    aobj.actorCriteriaResult.forEach(raobj => {
                                        if (raobj.criteriaAlternativeName === obj.alternativeName) {
                                            aScore += raobj.criteriaAlternativeScore
                                            overallscore = overallscore + raobj.criteriaAlternativeScore * aobj.actorCriteriaWeight
                                            // lineData.push(raobj.criteriaAlternativeScore)
                                            // finalResult += raobj.criteriaAlternativeScore * aobj.actorCriteriaWeight
                                        }
                                    })
                                }
                            })
                            aScore = aScore / evaList.length
                            lineData.push(aScore.toFixed(3))
                        }
                    }
                })

                overallscore = overallscore / evaList.length
                lineData.push(overallscore.toFixed(3))
                line.data = lineData
                line.symbol = lineSymbol[num]
                line.symbolSize = 12
                num++
                line.type = "line"
                line.lineStyle = {
                    width: 4
                }
                seriesData.push(line)
            })
        }
        criteriaName.push("Result score")
        // seriesData.push({
        //     name: 'Average result',
        //     type: 'bar',
        //     barWidth: '20%',
        //     itemStyle: {
        //         color: "#FFF",
        //         barBorderColor: 1
        //     },
        //     data: criteriaWeightValue,
        //     markPoint: {
        //         symbol: 'circle',
        //         symbolSize: 50,
        //     },
        // })
        seriesData.push({ //box
            name: 'Weight boxplot',
            type: 'boxplot',
            data: test,
            itemStyle: {
                color: "#FFF",
                borderColor: "#000",
                opacity: 0.5
            },
        })

        seriesData.push({ //extrem value
            name: 'outlier',
            type: 'scatter',
            itemStyle: {
                color: "#FFF",
                barBorderColor: 1
            },
            data: boxPlotData.outliers
        })
        var option = {}
        if (this.state.project.projectAlternatives) {
            option = {
                // color: ['#4C6F74'],
                title: {
                    text: `Actor average result: ${this.state.projectActorGroup.actorGroupName}`
                },
                legend: {
                    top: '5%',
                    textStyle: {
                        fontSize: 16 // Set the legend font size here
                    }
                },
                tooltip: {
                    trigger: 'axis',
                    axisPointer: {            // 坐标轴指示器，坐标轴触发有效
                        type: 'shadow'        // 默认为直线，可选为：'line' | 'shadow'
                    }
                },
                toolbox: {
                    feature: {
                        saveAsImage: {
                            title: "Save"
                        }, 
                        dataView: { title: "show data", show: true, readOnly: false },

                    }
                },
                grid: {
                    left: '3%',
                    right: '4%',
                    bottom: '3%',
                    containLabel: true
                },
                xAxis: [
                    {
                        type: 'category',
                        data: criteriaName,
                        axisLabel: {
                            show: true,
                            interval: 0,
                            // Use callback function; function parameters are axis index
                            formatter: function (value, index) {
                                // let textArray = value.split(" ")
                                let final = ""
                                if(parseInt(value.length/20) === 0){ //not long enough
                                    final = value
                                }
                                else{
                                    for (let i = 0; i < parseInt(value.length/20)+1; i++) {
                                        let t = value.substring((i)*20, (i+1)*20)+ '\n';
                                        final += t
                                      }
                                }
     
                                // var texts = value.substring(0, 5);
                                return final;
                            }
                        }
                    }
                ],
                yAxis: [
                    {
                        type: 'value',
                        max: 1.00,
                        min: 0.00
                    }
                ],
                series: seriesData
            };
        }
        return option
    }

    handleChart() {
        if (this.state.chart === "Overall result") {
            return this.getMAMCAOverallResult()
        }
        if (this.state.chart === "Sensitivity analysis") {
            return this.getMCASensitivityAnalysis()
        }
        if (this.state.chart === "Average actor group result") {
            return this.getWeightOption()
        }
    }

    onEvents = () => {
        return ({
            click: (params) => { //click event
                if (params.componentSubType === "bar" && this.state.chart === "Sensitivity analysis") {
                    this.setState({
                        changedName: params.name,
                        number: params.data
                    })
                }
                // if (this.state.chart === "Weight analysis") {
                //     this.state.projectActorGroup.actorCriteria.forEach(obj => {
                //         if (obj.criteriaName === params.name && obj.subCriteria && obj.subCriteria.length !== 0) { //find the criterion, should have criteria group that can be expanded
                //             this.setState({
                //                 selectedCriterion: params.name
                //             })
                //         }
                //     }
                //     )
                // }
            }
        })
    }
    //get the projects
    getProject = () => {
        fetch(`/invitedProject/getInvitedProject/${this.props.match.params.projectid}/${this.props.match.params.actorid}/${Cookie.get("email")}/`, { //get the project id from link
            method: 'GET',
            headers: {
                'Content-Type': 'application/json'
            },
        }).then(res => res.json())
            .then(json => {
                if (json.success) {
                    // let panes = []
                    // let index = 1
                    // json.project.projectActorGroup.forEach(obj => {
                    //     panes.push({ title: obj.actorGroupName, key: index, id: obj._id })
                    //     index++
                    // })
                    this.setState({
                        project: json.project,
                        projectName: json.project.projectName,
                        projectEvaluationType: json.project.projectEvaluationType,
                        projectActorGroup: json.projectActorGroup,
                        role: json.role,
                        number: 0,
                        changedName: "",
                        loading: false,
                    }) //save project data
                }
                else {
                    message.error(json.message)
                    this.props.history.push("/"); //redirect to homepage if the project not exist, shouldn't be a case
                }
            });
    }

    componentDidMount() {
        try {
            this.getProject() //after render immediately get alternative list
        } catch (e) {
            alert(e);
        }
    }

    render() {
        const Step = Steps.Step;
        //the step infomation
        const mamcaSteps = [{
            title: 'Alternatives',
        },
        {
            title: 'Criteria',
        }, {
            title: 'Weights',
        }, {
            title: 'Evaluation',
        }, {
            title: 'Result',
        }];
        return <div className="MCACriteria">
            <Spin size="large" tip="Loading..." spinning={this.state.loading}>
                <Row style={{ marginTop: "5vh" }} type="flex" justify="space-around">
                    <Col span={4}>
                        <h4>Project name: {this.state.projectName}</h4>
                    </Col>
                    <Col span={4}>
                        <h4>Evaluation type: {this.state.projectEvaluationType}</h4>
                    </Col>
                    <Col span={4}>
                        <h4>Role: {this.state.role}</h4>
                    </Col>
                </Row>
                <Divider />
                <Steps style={{ width: "80%", margin: "auto" }} current={4} onChange={this.onStepChange}>
                    {mamcaSteps.map(item => <Step key={item.title} title={item.title} />)}
                </Steps>
                <div className="steps-content"></div>
                <Button onClick={() => { this.setState({ chart: "Overall result" }) }} style={{ marginLeft: "0" }} type="primary" size="large">Overall result</Button>
                <Button onClick={() => { this.setState({ chart: "Sensitivity analysis" }) }} style={{ marginLeft: "2vh" }} type="primary" size="large">Sensitivity analysis</Button>
                <Button onClick={() => { this.setState({ chart: "Average actor group result" }) }} style={{ marginLeft: "2vh" }} type="primary" size="large">Average actor group result</Button>
                <div>&nbsp;</div>
                <ReactEcharts
                    option={this.handleChart()}
                    onEvents={this.onEvents()}
                    style={{ height: '75vh', width: '100%' }}
                />

                {this.state.changedName === "" ? <div></div> :
                    <div>
                        {this.state.chart === "Sensitivity analysis" ?
                            <Form>
                                <Form.Item
                                    label={"Change weight " + this.state.changedName}
                                >
                                    <Row type="flex" justify="start">
                                        <Col span={2}>
                                            <InputNumber
                                                min={0.1}
                                                max={0.9}
                                                step={0.01}
                                                value={this.state.number}
                                                onChange={this.handleNumberChange}
                                            />
                                        </Col>
                                        <Col span={4}>
                                            <Button onClick={this.getProject}>Reset</Button>
                                        </Col>
                                    </Row>
                                </Form.Item>
                            </Form>
                            : <div></div>}
                    </div>}
                {/* {this.state.chart === "Weight analysis" ?
                    <Button onClick={() => { this.setState({ selectedCriterion: "" }) }}>Reset</Button>
                    : <div></div>} */}
                <Divider />
                <div className="steps-action">
                    <Button size="large">
                        <Link to={`/invitedevaluation/${this.props.match.params.projectid}/${this.props.match.params.actorid}`}>Previous</Link>
                    </Button>
                </div>
            </Spin>
        </div>;
    }
}